import type { IconData } from '@equinor/eds-icons'

// Custom drone icon (not part of the EDS icon set) used on the Plant status cards.
export const aerialDrone: IconData = {
    name: 'aerial_drone',
    prefix: 'custom',
    height: '24',
    width: '24',
    svgPathData:
        'M22.707 16.707c-6.015 6.016-15.399 6.015-21.414 0l1.414-1.414c5.234 5.234 13.352 5.234 18.586 0zM20.04 14.04c-4.515 4.515-11.565 4.515-16.08 0l1.414-1.414c3.734 3.734 9.518 3.734 13.252 0zm-2.666-2.666c-3.015 3.015-7.732 3.015-10.747 0L8.041 9.96c2.234 2.234 5.685 2.234 7.919 0zM20 2a1 1 0 0 1 1 1h1a1 1 0 1 1 0 2h-1a1 1 0 1 1-2 0h-2.075L15.34 7.947A2 2 0 0 1 13.58 9h-2.837a2 2 0 0 1-1.713-.969L7.204 5H5a1 1 0 0 1-2 0H2a1 1 0 0 1 0-2h1a1 1 0 0 1 2 0h14a1 1 0 0 1 1-1m-9.257 5h2.836l1.075-2H9.54z',
}
